export const EDUCATIONAL_ROUTES = {
  tutorials: 'tutoriales',
};
